import axios from "axios";
import { useState } from "react";

import { updateNewsVisibilityApi } from "constants/ApiConst";
import useFirebaseContext from "hooks/useFirebaseContext";

type UpdateNewsVisibilityResponse = void;

const useUpdateNewsVisibility = () => {
  const { auth } = useFirebaseContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const updateVisibility = async (newsId: string, doNotDisplayAgain: boolean) => {
    if (!auth?.currentUser) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const token = await auth.currentUser.getIdToken();

      await axios.put<UpdateNewsVisibilityResponse>(
        updateNewsVisibilityApi(newsId).url,
        { doNotDisplayAgain },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      const error = err as Error;
      setError(error);
      console.error("API エラー:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { updateVisibility, isLoading, error };
};

export default useUpdateNewsVisibility;
